export const progressCellTheme = {
  bg: 'palette.tertiary.5',
  progress: { bg: 'palette.primary.20' },
};
